/* eslint-disable @nrwl/nx/enforce-module-boundaries */
import { Component, inject, input, Input, OnInit } from '@angular/core';
import { SwiperOptions } from 'swiper/types';

import { FeatureCarouselComponent } from '@usheru-hff/community-elements/utils';
import { NewsService } from '@usheru-hff/sdk/news';
import { News } from '@usheru-hff/shared/domain';
import { Observable } from 'rxjs';

@Component({
  selector: 'community-feature-news-carousel',
  templateUrl: './feature-news-carousel.component.html',
  styleUrls: ['./feature-news-carousel.component.scss'],
  standalone: false
})
/**
 * @description This component is used to display a carousel of movies, it will be in charge of
 * interpreting dashboard community movie slider parameters and displaying the movies in a carousel
 * applying given parameters
 */
export class FeatureNewsCarouselComponent extends FeatureCarouselComponent<News> {
  newsService = inject(NewsService);

  Array = Array;

  @Input() set news(news: News[]) {
    this.items = news;
  }
  @Input() viewAllLink: string | undefined = '/news';
  @Input() newsSubtitle =
    $localize`:@@public.commons.news.subtitle:Lore ipsum dolor sit amet, consectetur adipiscing elit.`;

  @Input() hideViewAll = false;

  @Input() hideOnZeroResults = false;

  isMovieStieConfig = input(false);

  news$?: Observable<News[]> | undefined = undefined;
  title = $localize`:@@title.news:News`;

  movieSiteSwiperConfig: SwiperOptions = {
    slidesPerView: 1,
    spaceBetween: 30,
    scrollbar: true,
    breakpoints: {
      480: {
        slidesPerView: 2,
        spaceBetween: 30
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 30
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 30
      }
    },
    pagination: {
      clickable: true,
      type: 'bullets'
    },
    autoplay: {
      delay: 5000
    },
    loop: true
  };

  /**
   * Overriding the method to fetch the news from the service with the params input
   */
  beforeInitSwiper() {
    this.updateNoItemsBinding();

    this.news$ = this.newsService.getNews(1, 10, this.params);
  }
}
